<template lang="pug">
    el-row(v-if="emissaoCusta !== null" :gutter="20")
      el-card
        el-col(:xl="12" :lg="12")
          el-card.cardDiaria
            p.label Diárias do Motorista
            div.row-label
              p.label Valor da diária:
              p {{formatarValores(emissaoCusta.valorMotorista.valor)}}
            div.row-label
              p.label Número de funcionários:
              p {{emissaoCusta.valorMotorista.quantidade}}
            div.row-label
              p.label Custo diária (por funcionário):
              p {{emissaoCusta.valorPorFuncionarioMotorista}}
            div.row-label
              p.label Custo total pessoal:
              p {{formatarValores(emissaoCusta.valorMotorista.total)}}

        el-col(:xl="12" :lg="12")
          el-card.cardDiaria
            p.label Diárias de Vistoria
            div.row-label
              p.label Valor da diária:
              p {{formatarValores(emissaoCusta.valorVistoria.valor)}}
            div.row-label
              p.label Número de funcionários:
              p {{emissaoCusta.valorVistoria.quantidade}}
            div.row-label
              p.label Custo diária (por funcionário):
              p {{emissaoCusta.valorPorFuncionarioVistoria}}
            div.row-label
              p.label Custo total pessoal:
              p {{formatarValores(emissaoCusta.valorVistoria.total)}}

        el-col(:xl="12" :lg="12")
          el-card.cardDiaria
            p.label Diárias de Demarcação e Fiscalização
            div.row-label
              p.label Valor da diária:
              p {{formatarValores(emissaoCusta.valorDemarcacao.valor)}}
            div.row-label
              p.label Número de funcionários:
              p {{emissaoCusta.valorDemarcacao.quantidade}}
            div.row-label
              p.label Custo diária (por funcionário):
              p {{emissaoCusta.valorPorFuncionarioDemarcacao}}
            div.row-label
              p.label Custo total pessoal:
              p {{formatarValores(emissaoCusta.valorDemarcacao.total)}}

        el-col(:xl="12" :lg="12")
          el-card.cardDiaria
            el-row.row-label(:xl="8" :lg="8")
              p.label Diárias:
              p {{emissaoCusta.numeroDiarias}}
            el-row.row-label(:xl="8" :lg="8")
              p.label Município:
              p {{emissaoCusta.municipio.nome}}
            el-row.row-label(:xl="8" :lg="8")
              p.label Fator Município
              p {{emissaoCusta.fatorLocalizacao}}
            el-row.row-label(:xl="8" :lg="8")
              p.label Total:
              p {{formatarValores(emissaoCusta.valorTotal)}}
</template>
<script>
export default {
  data () {
    return {
      cardDiaria: 'height: 200px; margin-bottom: 20px'
    }
  },
  props: {
    emissaoCusta: {
      type: Object,
      required: true
    }
  },
  methods: {
    formatarValores (valor) {
      return new Intl.NumberFormat('pt-BR', {
        style: 'currency',
        currency: 'BRL'
      }).format(valor)
    }
  }
}
</script>
<style>

.cardDiaria {
  display: flex;
  align-items: center;
  height: 200px;
  margin-bottom: 20px;
}

.row-label {
  display: flex;
  align-items: center;
  gap: 10px;
}

.label {
  font-weight: bold;
}

</style>



// WEBPACK FOOTER //
// src/components/VisualizarEmissaoCustas.vue